export enum DependenciaAdministrativa {
    Federal = 1,
    Estadual = 2,
    Municipal = 3,
    PrivadaConvSemFins = 4,
    PrivadaConvComFins = 5,
    PrivadaNConvSemFins = 6,
    PrivadaNConvComFins = 7
}